import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const OurFleet = () => {
  const fleet = [
    {
      title: "Swift Dzire",
      seats: "Seats: 4+1 Seater",
      description:
        "A compact, fuel-efficient sedan perfect for city commutes, airport pickups, and solo or couple travelers. With plush seating and air conditioning, Swift Dzire offers a smooth and budget-friendly ride.",
      image: "/images/ourfleets/1.jpg",
      link: "#",
      color: "#ff6600",
    },
    {
      title: "Aura",
      seats: "Seats: 4+1 Seater",
      description:
        "Aura is a modern sedan with ample space and comfort, ideal for quick business or leisure trips in and around the city. It offers reliability, comfort, and an elegant design.",
      image: "/images/ourfleets/2.jpg",
      link: "#",
      color: "#d8a300",
    },
    {
      title: "Toyota Rumion",
      seats: "Seats: 6+1 Seater",
      description:
        "Toyota Rumion is a premium 7-seater MPV based on the Suzuki Ertiga platform. Known for its elegant design, superior comfort, and Toyota’s strong reliability, it’s perfect for families and groups.",
      image: "/images/ourfleets/3.jpg",
      link: "#",
      color: "#ff6600",
    },
    {
      title: "Innova Crysta",
      seats: "Seats: 6+1 Seater",
      description:
        "Innova Crysta defines luxury travel with its powerful engine, premium interiors, and smooth ride. Perfect for long-distance tours, corporate travel, and family vacations.",
      image: "/images/ourfleets/4.jpg",
      link: "#",
      color: "#d8a300",
    },
    {
      title: "Ertiga",
      seats: "Seats: 6+1 Seater",
      description:
        "The Ertiga combines comfort and space for families and small groups. With fuel efficiency and modern features, it’s a versatile choice for both city and outstation rides.",
      image: "/images/ourfleets/5.jpg",
      link: "#",
      color: "#ff6600",
    },
    {
      title: "Kia Carens",
      seats: "Seats: 6+1 Seater",
      description:
        "A premium MPV, Kia Carens is stylish, spacious, and loaded with modern features for city and outstation trips.",
      image: "/images/ourfleets/6.jpg",
      link: "#",
      color: "#d8a300",
    },
    {
  title: "Innova",
  seats: "Seats: 6+1 Seater",
  description:
    "The classic 6-seater Innova is great for all terrain rides with comfort and durability.",
  image: "/images/ourfleets/7.jpg",
  link: "#",
  color: "#ff6600",
},
{
  title: "Fortuner",
  seats: "Seats: 6+1 Seater",
  description:
    "A powerful and luxurious SUV for elite travel, off-road adventures, or stylish wedding entries.",
  image: "/images/ourfleets/8.avif",
  link: "#",
  color: "#d8a300",
},
{
  title: "Tempo Traveller",
  seats: "Seats: 9, 12, 13, 17, 20 Seater",
  description:
    "Available in multiple seating options, Tempo Traveller is ideal for group tours, corporate trips, or religious outings.",
  image: "/images/ourfleets/9.jpg",
  link: "#",
  color: "#ff6600",
},
{
  title: "Urbania",
  seats: "Seats: 13, 17, 20 Seater",
  description:
    "Urbania is a modern minibus with a spacious interior, perfect for large families or team travel.",
  image: "/images/ourfleets/10.jpg",
  link: "#",
  color: "#d8a300",
},
{
  title: "Mini Bus",
  seats: "Seats: 21–27 Seater",
  description:
    "Mini Bus accommodates up to 27 passengers and is perfect for schools, offices, and tourist groups.",
  image: "/images/ourfleets/11.webp",
  link: "#",
  color: "#ff6600",
},
{
  title: "Luxury Bus",
  seats: "Seats: 35–45 Seater",
  description:
    "Luxury Bus is built for comfort and class — best for weddings, events, and long tours.",
  image: "/images/ourfleets/12.jpg",
  link: "#",
  color: "#d8a300",
},

  ];

  return (
<>



 <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Our Fleet
</h1>
          </div>
        </div>
      </section>

    <section className="our-fleet-section py-5">
      <div className="container">
        {/* <h2 className="fleet-title text-center mb-5">Our Fleet</h2> */}
        <div className="row">
          {fleet.map((car, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="fleet-card h-100">
                <img src={car.image} alt={car.title} className="fleet-img" />
                <div className="fleet-body p-3">
                  <h4 className="fleet-name">{car.title}</h4>
                  <p className="fleet-seats">{car.seats}</p>
                  <p className="fleet-desc">{car.description}</p>
                  <a
                    href={car.link}
                    className="fleet-btn"
                    style={{ backgroundColor: car.color }}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</>
  );
};

export default OurFleet;
